import React, {Component} from 'react';
import NavigationApi from "../../api/NavigationApi";
import AppLink from "../AppLink";

class Footer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      items: {}
    }
  }

  componentDidMount() {
    NavigationApi.menu().then(res => {
      this.setState({
        loading: false,
        items: res.data
      }, () => {
        const height = document.querySelector('.page-footer').clientHeight;
        let content = document.querySelector('.content-area');
        if (content) {
          content.style.paddingBottom = (height + 20) + "px";
        }
      });
    });
  }

  render() {
    const { loading, items } = this.state;

    return (
      <footer className="page-footer">
        <div className="container">
          <div className="util-links">
            <div className="row with-gutters">
              <div className="col-xs-12 col-sm-4">
                <h5>Useful Links</h5>
                {!loading && items.footer && items.footer.map(item => {
                  return <AppLink key={item.url || item.slug} to={item.url || item.slug}>{item.name || item.title}</AppLink>
                })}
              </div>
              <div className="col-xs-12 col-sm-4">
                <h5>Partner</h5>
                {!loading && items.partner && items.partner.map(item => {
                  return <AppLink key={item.url || item.slug} to={item.url || item.slug}>{item.name || item.title}</AppLink>
                })}
              </div>
              <div className="col-xs-12 col-sm-4">
                <h5>Premium Partner</h5>

                {!loading && items.premium && items.premium.map(item => {
                  return <AppLink key={item.url || item.slug} to={item.url || item.slug}>{item.name || item.title}</AppLink>
                })}
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;